import { History } from "history";

import {
  GET_ADMIN_ANALYTICS,
  GET_ADMIN_ANALYTICS_ERROR,
  GET_ADMIN_ANALYTICS_SUCCESS,
  GET_ADMIN_ANALYTICS_V2,
  GET_ADMIN_ANALYTICS_V2_ERROR,
  GET_ADMIN_ANALYTICS_V2_SUCCESS,
  GetAdminAnalyticsAction,
  GetAdminAnalyticsErrorAction,
  GetAdminAnalyticsSuccessAction,
  GetAdminAnalyticsV2Action,
  GetAdminAnalyticsV2ErrorAction,
  GetAdminAnalyticsV2SuccessAction,
} from "./actionTypes";
import {
  AdminAnalyticsRequest,
  AdminAnalyticsResponse,
} from "../../interfaces/analytics";

//#region Get AdminAnalytics

export const getAdminAnalytics = (
  query: AdminAnalyticsRequest
): GetAdminAnalyticsAction => {
  return {
    type: GET_ADMIN_ANALYTICS,
    payload: { query },
  };
};

export const getAdminAnalyticsSuccess = (
  response: AdminAnalyticsResponse
): GetAdminAnalyticsSuccessAction => {
  return {
    type: GET_ADMIN_ANALYTICS_SUCCESS,
    payload: response,
  };
};

export const getAdminAnalyticsError = (
  error: any
): GetAdminAnalyticsErrorAction => {
  return {
    type: GET_ADMIN_ANALYTICS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get AdminAnalytics

export const getAdminAnalyticsV2 = (
  query: AdminAnalyticsRequest
): GetAdminAnalyticsV2Action => {
  return {
    type: GET_ADMIN_ANALYTICS_V2,
    payload: { query },
  };
};

export const getAdminAnalyticsV2Success = (
  response: AdminAnalyticsResponse
): GetAdminAnalyticsV2SuccessAction => {
  return {
    type: GET_ADMIN_ANALYTICS_V2_SUCCESS,
    payload: response,
  };
};

export const getAdminAnalyticsV2Error = (
  error: any
): GetAdminAnalyticsV2ErrorAction => {
  return {
    type: GET_ADMIN_ANALYTICS_V2_ERROR,
    payload: error,
  };
};

//#endregion
